import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 6);
  const allCategories = categories;

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-foreground-500 text-xs font-medium tracking-wider uppercase">
              最新资讯
            </span>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight mt-2">
              最新吃瓜
              <br />
              不容错过
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            <span className="px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium whitespace-nowrap">全部</span>
            {allCategories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-3 py-1.5 bg-background-200/70 text-foreground-600 rounded-full text-xs font-medium hover:bg-secondary-100 hover:text-secondary-900 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link key={article.id} to={`/article/${article.slug}`} className="block h-full">
              <article className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer h-full flex flex-col">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={`${article.title} - 51在线吃瓜`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-foreground-950 text-base font-medium leading-snug mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <div className="flex flex-wrap gap-1.5">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 bg-secondary-100 text-secondary-800 rounded text-xs whitespace-nowrap"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}